module.exports = "build/assets/RingsideRegular-Bold.50c2c75c.ttf";